import api from '@/lib/api';
import { detectDeviceModel } from '@/lib/deviceModel';

/**
 * Best-effort client error reporting to the admin "Log Errori"
 * (POST /error-logs/client). Deduped by key so a re-render loop can't
 * flood the log; failures are swallowed — logging must never break the UI.
 *
 * Every report is auto-enriched with the technical context needed for
 * debugging (page, viewport, device model, language, connectivity); the
 * server adds userId/role/userName/userEmail and the raw User-Agent.
 */
const reported = new Set<string>();

export interface ClientErrorPayload {
  code?: string;
  message: string;
  context?: Record<string, unknown>;
}

function baseDebugContext(): Record<string, unknown> {
  return {
    url: `${window.location.pathname}${window.location.search}`,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    language: navigator.language,
    online: navigator.onLine,
  };
}

export function reportClientErrorOnce(key: string, payload: ClientErrorPayload): void {
  if (reported.has(key)) return;
  reported.add(key);
  void (async () => {
    const deviceModel = await detectDeviceModel();
    await api.post('/error-logs/client', {
      ...payload,
      context: {
        ...baseDebugContext(),
        ...(deviceModel ? { deviceModel } : {}),
        ...payload.context,
      },
    });
  })().catch(() => {});
}

export function __resetReportedForTests(): void {
  reported.clear();
}
